// extracted by mini-css-extract-plugin
module.exports =  {"menu":"_35875ce240--menu--pk9He","menu-item":"_35875ce240--menu-item--gVGrr","menu-item--active":"_35875ce240--menu-item--active--RueXq"};